import { googleDrive } from '../../services/googleDrive';
import { getTokenOrRefresh } from '../../services/googleAuth';
import { logger } from '../../utils/logger';

// Verificar autenticação E estrutura de pastas ao inicializar
export const ensureAuthenticated = async () => {
  // getTokenOrRefresh tenta token síncrono, depois refresh, depois throw
  const token = await getTokenOrRefresh();

  // Garantir que a estrutura de pastas existe no Drive
  // Isso cria a pasta Bigwa_App se não existir
  try {
    await googleDrive.initialize();
  } catch (error) {
    logger.error('DriveProjectStore', 'Erro ao inicializar estrutura do Drive:', error);
    // Se falhar, tentar novamente após refresh
    const refreshedToken = await getTokenOrRefresh();
    if (!refreshedToken) {
      throw new Error('Authentication expired. Please log in again.');
    }
    await googleDrive.initialize();
  }

  return token;
};
